import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
// report-common
//////////////////////////////////////////////////

const store = (state) => state.fuelCards;

const reportStore = createSelector(
  store,
  ({ truckGuid, driverGuid, fullReport, profileReport }) => G.ifElse(
    G.isOneNotNilOrNotEmpty([truckGuid, driverGuid]),
    profileReport,
    fullReport,
  ),
);

// report selectors
const makeSelectReportStatus = () => createSelector(
  reportStore,
  (state) => state.reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  reportStore,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  reportStore,
  ({ usedReport }) => usedReport,
);

const makeSelectItemList = () => createSelector(
  reportStore,
  ({ itemList }) => itemList,
);

const makeSelectPagination = () => createSelector(
  reportStore,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  reportStore,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  reportStore,
  ({ loading }) => loading,
);

const makeSelectTableTitleFilters = () => createSelector(
  reportStore,
  ({ tableTitleFilters }) => tableTitleFilters,
);

const makeSelectTitleSortValues = () => createSelector(
  reportStore,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectSelectedList = () => createSelector(
  reportStore,
  R.compose(
    R.keys,
    R.filter(R.prop('selected')),
    R.propOr([], 'itemList'),
  ),
);
// report selectors

const makeSelectDriverList = () => createSelector(
  store,
  ({ driverList }) => driverList,
);

const makeSelectTruckList = () => createSelector(
  store,
  ({ truckList }) => truckList,
);

const makeSelectTruckGuid = () => createSelector(
  store,
  ({ truckGuid }) => truckGuid,
);

const makeSelectDriverGuid = () => createSelector(
  store,
  ({ driverGuid }) => driverGuid,
);

const makeSelectShowUnemployedDrivers = () => createSelector(
  store,
  ({ showUnemployedDrivers }) => showUnemployedDrivers,
);

const makeSelectShowIsNotInServiceTrucks = () => createSelector(
  store,
  ({ showIsNotInServiceTrucks }) => showIsNotInServiceTrucks,
);

const makeSelectDriverAssignmentsTrucks = () => createSelector(
  store,
  ({ driverAssignmentsTrucks }) => driverAssignmentsTrucks,
);

const makeSelectAdditionalSearchCriteria = () => createSelector(
  store,
  R.propOr([], 'additionalSearchCriteria'),
);

export {
  makeSelectItemList,
  makeSelectTruckGuid,
  makeSelectTruckList,
  makeSelectDriverGuid,
  makeSelectUsedReport,
  makeSelectDriverList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectSelectedList,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectShowUnemployedDrivers,
  makeSelectDriverAssignmentsTrucks,
  makeSelectAdditionalSearchCriteria,
  makeSelectShowIsNotInServiceTrucks,
};
